<template>
  <div>
<!-- Footer Section Begin -->
<footer class="footer-section" v-if="dados.length">
        <div class="container">
            <div class="row">
                <div class="col-lg-3">
                    <div class="footer-left">
                        <div class="footer-logo">
                            <div> <!--style="background-color: #ffffff;padding: 10px;border-radius: 5px;text-align: center;width: 200px;"-->
                               <img src="/images/logo-sub-4.png" alt="">
                            </div>
                        </div>
                        <ul>
                            <li>{{ $localeField(dados[0], 'itiNome') }} </li>
                            <li><a :href="dados[0].itiCampoExtra1" target="_blank" style="color: #ffffff;font-size: 16px;"> {{ $localeField(dados[0], 'itiReferencia') }}</a> </li>
                            <li> <p v-html="$localeHtml(dados[0], 'itiResumo1')"></p></li>
                        </ul>
                        <div class="footer-social">
                            <template v-if="redes.length">
                              <a v-if="redes[0].itiNome" :href="redes[0].itiNome" class="social-icon" target="_blank" title="Facebook"><i class="fa fa-facebook"></i></a>
                              <a v-if="redes[0].itiReferencia" :href="redes[0].itiReferencia" class="social-icon" target="_blank" title="Instagram"><i class="fa fa-instagram"></i></a>
                              <a v-if="redes[0].itiCampoExtra1" :href="redes[0].itiCampoExtra1" class="social-icon" target="_blank" title="Youtube"><i class="fa fa-youtube"></i></a>
                              <a v-if="redes[0].itiCampoExtra2" :href="redes[0].itiCampoExtra2" class="social-icon" target="_blank" title="Linkedin"><i class="fa fa-linkedin"></i></a>
                            </template>
                          </div>
                    </div>
                </div>
                <div class="col-lg-2 offset-lg-1">
                    <div class="footer-widget">
                        <h5>{{ $t('footer.institutional') }}</h5>
                        <ul>
                            <li><router-link to="/">{{ $t('footer.home') }}</router-link></li>
                            <li><router-link to="/sobre">{{ $t('footer.about') }}</router-link></li>
                            <!--li><router-link to="/cambio">Câmbio</router-link></!--li-->
                            <li><router-link to="/blog">{{ $t('footer.blog') }}</router-link></li>
                            <li><router-link to="/faleconosco">{{ $t('footer.contact') }}</router-link></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-2">
                    <div class="footer-widget">
                        <h5>{{ $t('footer.packages') }}</h5>
                        <ul>
                            <li v-for="seg in SegmentosMenu" :key="seg.psgId">
                              <router-link :to="'/Produtos/' + seg.psgId + '/' + seg.psgNomeSegmento.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', '')">
                                        {{ $localeField(seg, 'psgNomeSegmento') }}
                                    </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="footer-widget">
                        <h5>{{ $t('footer.policies') }}</h5>
                        <ul>
                          <li v-for="itens in informacoes" :key="itens.itiId">
                                <router-link :to="'/informacoes/' + itens.itiId + '/' + (itens.itiNome || '').replaceAll(' ','-').replaceAll('/','').replaceAll(',','')">
                                  {{ $localeField(itens, 'itiNome') }}
                              </router-link>
                          </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="copyright-reserved">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="copyright-text">
                            <a href="https://avancedigital.com.br" target="_blank">Avance Digital</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <div v-if="dados.length" class="whatsapp-fixo">
        <a :href="dados[0].itiCampoExtra1" target="_blank">
            <img src="/images/atendimentowats.png"  :alt="$t('footer.whatsappAlt')" />
        </a>
       </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'PageFooter',
  components: {

  },
  data: () => ({
    dados: [],
    redes:[],
    informacoes:[],
    callaction:[],
    LinkWhats:[],
    Segmentos: [],
    SegmentosMenu: [],
  }),
  methods: {

  },
  created() {  
    axios.get('/Process/InsInstitucional/institucional/10/rodape')
         .then(response => {
         this.dados = response.data;
       })
       .catch(error => {
         console.error(error);
       });

     axios.get('/Process/InsInstitucional/institucional/20/redessociais')
         .then(response => {
         this.redes = response.data;
       })
       .catch(error => {
         console.error(error);
       });

    axios.get('/Process/InsInstitucional/institucional/18/informacoes')
         .then(response => {
         this.informacoes = response.data.filter(x=> x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
       })
       .catch(error => {
         console.error(error);
       });

       axios.get('/Process/ProSegmentos/GetAll')
            .then(response => {
                this.Segmentos = response.data;
                this.SegmentosMenu = this.Segmentos.filter(x => x.psgIdPai == 0 && x.psgVisivel).sort((a, b) => {
                    const nomeA = a.psgNomeSegmento || "";
                    const nomeB = b.psgNomeSegmento || "";
                    return nomeA.localeCompare(nomeB);
                });
            })
            .catch(error => {
                console.error(error);
            });
  }
}
</script>

<style>
.menuTamanho {
  font-size: 20px;
  text-align: center;
}

ul li p p {
  color: #ffffff !important;
}

/* WHATSAPP FIXO */
.whatsapp-fixo {
      position: fixed;
      bottom: 10px;
      right: 10px;
      z-index: 999;
  }
</style>
